import $i18n from '@/locales/i18n';
import { createBlockSnippet } from '@/common/manager/setter-snippet';
import isNumber from 'lodash/isNumber';
import { isArrayNotEmpty } from './util';
const CnMessage = window.CNUI?.CnMessage;
/**
 * @description 通过块，在画布中插入新栏
 */
function insertNewBlock(config) {
    const { currentBlockInfo, _leaf } = config || {};
    const { currentIndex, groupList = [], currentLine, currentLineBlockNum } = currentBlockInfo || {};
    if (!isNumber(currentLineBlockNum) || !isNumber(currentLine)) {
        return;
    }
    if (currentLineBlockNum < 6) {
        const sectionNode = _leaf?.parent;
        if (sectionNode?.componentName === 'CnLayoutSection') {
            const children = sectionNode?.schema?.children;
            if (isArrayNotEmpty(children)) {
                const currentLineStartIndex = groupList[currentLine]?.[0]?.index;
                const currentLineBlock = children.slice(currentLineStartIndex, currentLineStartIndex + currentLineBlockNum);
                const realChildren = [];
                currentLineBlock.forEach((item) => {
                    const nodeId = item.id;
                    if (nodeId) {
                        realChildren.push({
                            nodeId,
                            span: currentLineBlock.length === 4 ? 2 : 12 / (currentLineBlockNum + 1),
                        });
                    }
                });
                const document = _leaf?.document;
                realChildren?.forEach?.((item) => {
                    const node = document?.getNode?.(item.nodeId);
                    // @ts-ignore 忽略第3个参数，走默认值
                    node?.setPropValue?.('span', item.span);
                });
                let cardProps = {
                    title: $i18n.get({ id: 'Title', dm: '标题' }),
                };
                const parent = sectionNode?.parent;
                if (parent?.componentName === 'CnCard') {
                    cardProps = {
                        noPadding: true,
                        noShadow: true,
                        title: $i18n.get({ id: 'Title', dm: '标题' }),
                        shape: 'simple',
                    };
                    if (parent?.propsData?.shape === 'group') {
                        cardProps.noPadding = false;
                        cardProps.noShadow = false;
                        cardProps.shape = 'normal';
                    }
                }
                const blockSchema = createBlockSnippet({
                    cardProps,
                    blockProps: {
                        span: currentLineBlock.length === 4 ? 4 : 12 / (currentLineBlockNum + 1),
                    },
                });
                const newNode = _leaf?.document?.createNode(blockSchema);
                // @ts-ignore ...
                newNode && sectionNode?.insertAfter(newNode, { index: currentIndex });
            }
        }
    }
    else {
        CnMessage?.error?.($i18n.get({ id: 'ASingleRowCannotExceed6Columns', dm: '单行不能超过6栏' }));
    }
}
/**
 * @description 获取当前块信息
 */
function getCurrentBlockInfo({ _nodeId, _leaf, }) {
    const children = _leaf?.parent?.schema?.children;
    const result = {};
    if (isArrayNotEmpty(children)) {
        let currentIndex;
        result.groupList = groupColumn(children.map((item, index) => {
            const nodeId = item.id;
            const nodeProps = item.props;
            if (nodeId === _nodeId) {
                currentIndex = index;
            }
            return nodeProps?.span;
        }));
        if (currentIndex !== undefined) {
            result.currentIndex = currentIndex;
            result.groupList?.forEach((line, index) => {
                const currentLineIndex = line.findIndex((item2) => {
                    return item2.index === currentIndex;
                });
                if (currentLineIndex !== -1) {
                    // 计算属于哪行
                    result.currentLine = index;
                    // 当前行的已有的块数
                    result.currentLineBlockNum = line.length;
                    // 当前行的已有的块数
                    result.currentLineIndex = currentLineIndex;
                }
            });
        }
    }
    return result;
}
/**
 * @description 对列进行分组
 */
function groupColumn(arr) {
    const groups = [];
    let currentGroup = [];
    let currentSum = 0;
    for (const [numberIndex, numberStr] of arr.entries()) {
        // 将字符串数字转换为整数
        const number = parseInt(numberStr, 10);
        currentSum += number;
        if (currentSum <= 12) {
            currentGroup.push({ index: +numberIndex, value: number });
        }
        else {
            groups.push(currentGroup);
            currentGroup = [{ index: +numberIndex, value: number }];
            currentSum = number;
        }
    }
    // 处理最后一组（如果不为空）
    if (currentGroup.length > 0) {
        groups.push(currentGroup);
    }
    return groups;
}
function calculateAfterGroupList({ beforeGroupList, direction, groupInnerIndex, }) {
    // 单行最后一个块不允许拖拽
    if (groupInnerIndex === beforeGroupList?.length - 1) {
        return [];
    }
    const afterGroupList = [];
    // 2024.10更新afterGroupList计算逻辑，不再走BLOCK_RESIZE_MAP映射
    for (let i = 0; i < beforeGroupList.length; i++) {
        const span = beforeGroupList[i];
        const numSpan = Number(span);
        const offset = direction === 'r' ? 1 : -1;
        let targetSpan = numSpan;
        if (i === groupInnerIndex) {
            targetSpan = numSpan + offset;
            if ((targetSpan > 12 && direction === 'r') || (targetSpan < 2 && direction === 'l')) {
                return [];
            }
        }
        else if (i === groupInnerIndex + 1) {
            targetSpan = numSpan - offset;
            if ((targetSpan > 12 && direction === 'l') || (targetSpan < 2 && direction === 'r')) {
                return [];
            }
        }
        afterGroupList.push(`${targetSpan}`);
    }
    return afterGroupList;
}
/**
 * @description 根据Schema生成新Node替换原始Node（先删除再生成新Node，保证NodeId不变）
 * @param preNode 原始Node
 * @param newSchema 新Schema
 */
function replaceNode(preNode, newSchema) {
    const { prevSibling, nextSibling } = preNode || {};
    preNode?.remove();
    const newNode = preNode?.document?.createNode(newSchema);
    if (prevSibling) {
        preNode.parent?.insertAfter(newNode, prevSibling, false);
        return;
    }
    preNode.parent?.insertBefore(newNode, nextSibling || undefined, false);
}
export { insertNewBlock, getCurrentBlockInfo, groupColumn, calculateAfterGroupList, replaceNode };
